import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { TokenStorage } from '../Utility/TokenStorage';
import { ServerConstantsService } from './server-constants.service';


@Injectable()
export class AuthService {
  ServerConstants: any;

  constructor(
    private http: HttpClient,
    private tokenStorage: TokenStorage,
    private serverConstantsService: ServerConstantsService,
  ) {
    this.ServerConstants = serverConstantsService.getConstants();
  }

  attemptAuth(inputLoad: any): Observable<any> {
    const credentials = {username: inputLoad.username, password: inputLoad.password};
    return this.http.post<any>(this.ServerConstants.SERVER_URL + '/token/generate-token', inputLoad);
  }

  //Function to retrieve authentication status
  isAuthenticated(){
    return (this.tokenStorage.getToken() ? true : false);
  }

  signIn(inputLoad: any){
    this.tokenStorage.saveSession(inputLoad);
  }

  signOut(){
    this.tokenStorage.clearSession();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/auth.service.ts